module.exports = "/_next/static/images/loading_22-1d805ad77fc9081279148ea4bc4afb14.png";